export const ROUTES = {
  AUTH: {
    LOGIN: "/auth/login",
    LOGIN_WITH_EMAIL: (email: string) => `/auth/login?email=${encodeURIComponent(email)}` as const,
    RESET_PASSWORD: "/auth/reset-password",
    CONFIRM_EMAIL_CHANGE: "/auth/confirm-email-change",
    VERIFY_EMAIL: "/auth/verify-email",
    VERIFY_EMAIL_LINK: "/verify-email",
  },
  DASHBOARD: "/",
  TASKS: "/tasks",
  ACTIVITY: "/activity",
  QUOTAS: "/quotas",
  PROPOSALS: { DETAIL: (uuid: string) => `/proposals/${uuid}` as const },
  PORTAL_UNAVAILABLE: "/portal-unavailable",
  BENEFICIARIES: {
    LIST: "/beneficiaries",
    DETAIL: (id: string) => `/beneficiaries/${id}` as const,
    QUOTA: (id: string, quotaId: string) => `/beneficiaries/${id}/quotas/${quotaId}` as const,
    AUDIT: (id: string, quotaId: string) => `/beneficiaries/${id}/quotas/${quotaId}/audit` as const,
    INVESTMENT: (id: string, quotaId: string, investmentId: string) =>
      `/beneficiaries/${id}/quotas/${quotaId}/investments/${investmentId}` as const,
  },
  INVESTORS: {
    DETAIL: (id: string) => `/investors/${id}` as const,
    INVESTMENT: (id: string, investmentId: string) =>
      `/investors/${id}/investments/${investmentId}` as const,
    PROPOSAL: (id: string, proposalId: string) =>
      `/investors/${id}/proposals/${proposalId}` as const,
  },
  PROJECTS: {
    DETAIL: (id: string) => `/projects/${id}` as const,
  },
  INVESTMENTS: {
    INVESTORS: "/investors",
    MAIN: "/investments",
    CALCULATOR: "/calculator",
    CALCULATOR_FOR_INVESTOR: (investorUuid: string) =>
      `/calculator?investor=${encodeURIComponent(investorUuid)}` as const,
    CONTRACTS: "/contracts",
    CONTRACT_DETAIL: (uuid: string) => `/contracts/${uuid}` as const,
    DETAIL: (uuid: string) => `/investments/${uuid}` as const,
  },
  ORGANIZATION: {
    ACTIVITY: "/settings/organization/activity",
    GENERAL: "/settings/organization",
    USERS: "/settings/members",
    TAGS: "/settings/organization/tags",
    MEMBERSHIPS: "/settings/organization/memberships",
    TEMPLATES: "/templates",
    TEMPLATE_DETAIL: (id: string) => `/templates/${id}` as const,
  },
  ADMIN: {
    ROOT: "/admin",
    DASHBOARD: "/admin/dashboard",
    ORGANIZATIONS: "/admin/organizations",
    ORGANIZATION_DETAIL: (uuid: string) => `/admin/organizations/${uuid}` as const,
    USERS: "/admin/users",
    USER_DETAIL: (uuid: string) => `/admin/users/${uuid}` as const,
  },
  HUB: {
    ROOT: "/hub",
    DASHBOARD: "/hub/dashboard",
    PROFILE: "/hub/profile",
    INVESTMENT_DETAIL: (uuid: string) => `/hub/investments/${uuid}` as const,
    INVESTMENT_ACTION: (uuid: string) => `/hub/investments/${uuid}/action` as const,
    DOCUMENT_VIEW: (uuid: string, docUuid: string) =>
      `/hub/investments/${uuid}/documents/${docUuid}` as const,
    SIGNING_CALLBACK: "/hub/signing-callback",
  },
  SETTINGS: "/settings",
  PROFILE: "/settings/profile",
  PREFERENCES: "/settings/preferences",
  NOTIFICATIONS: "/settings/notifications",
  SECURITY: "/settings/security",
  HELP: "/help",
  INVITATIONS: {
    ACCEPT: (orgUuid: string, invitationId: string) =>
      `/organizations/${orgUuid}/invitations/${invitationId}/accept` as const,
  },
} as const;

export const PEEK_PARAM = "peek";
export const CREATE_PARAM = "create";

export const withPeek = (path: string, uuid: string) =>
  `${path}?${PEEK_PARAM}=${encodeURIComponent(uuid)}`;

export const withCreateIntent = (path: string, context: Record<string, string> = {}) =>
  `${path}?${new URLSearchParams({ [CREATE_PARAM]: "1", ...context }).toString()}`;
